import * as React from 'react';
import { Button } from 'semantic-ui-react';
import { TitleBar } from '@/components/Common';
import enhance from './enhance';
import { paths } from '@/config';
import { Link } from 'react-router-dom';

import './styles.scss';

// 売上げ受取口座の登録状態。サーバーの connect_type と対応する。
const CONNECT_TYPE_NONE = 'none';

// 売上げ受取口座の登録状況。サーバーの onboarding_status と対応する。
const ONBOARDING_STATUS_NONE = 'none';
const ONBOARDING_STATUS_UNDER_REVIEW = 'under_review';
const ONBOARDING_STATUS_RESTRICTED = 'restricted';

// UnregisteredMessage は登録が完了していない理由を出し分ける。
// 判定が4通りあるため、三項演算子を重ねずに関数へ切り出している。
function UnregisteredMessage(props) {
  const { isRegistered, isUnderReview, isRestricted } = props;

  if (isRestricted) {
    return (
      <p>
        口座登録が完了できませんでした。
        <br />
        恐れ入りますが
        <Link to={paths.common.contact} target="_blank">
          お問い合わせ
        </Link>
        よりご連絡ください。
      </p>
    );
  }

  if (isUnderReview) {
    return (
      <p>
        Stripeの口座登録審査中です。
        <br />
        審査が完了するまで、売上金をお受け取りいただけません。
      </p>
    );
  }

  if (isRegistered) {
    return (
      <p>
        口座登録が完了していません。
        <br />
        このままでは売上金をお受け取りいただけません。
      </p>
    );
  }

  return <p>売上げ受取口座が登録されていません</p>;
}

function BankAccount(props) {
  const {
    handleConnectStripe,
    handleResumeOnboarding,
    isLoading,
    users,
  } = props;
  // 取得前や取得失敗時は未登録として扱う。connectType が未定義のときに
  // 「登録済み」と判定してしまうと、口座登録の導線が消えてしまうため。
  const myShop = users.myShop || {};
  const connectType = myShop.connectType || CONNECT_TYPE_NONE;
  const onboardingCompleted = Boolean(myShop.onboardingCompleted);
  const onboardingStatus = myShop.onboardingStatus || ONBOARDING_STATUS_NONE;

  const isRegistered = connectType !== CONNECT_TYPE_NONE;
  const isUnderReview = onboardingStatus === ONBOARDING_STATUS_UNDER_REVIEW;
  // Stripe が利用を停止・却下した状態。ユーザーが登録をやり直しても解決しないため、
  // オンボーディングへ戻す導線は出さない。
  const isRestricted = onboardingStatus === ONBOARDING_STATUS_RESTRICTED;

  return (
    <div>
      <TitleBar title="売上げ受取方法" />
      <section className="app__bank-account">
        <span className="payments flex">
          <section className="payments_container">
            <div className="sell_fish">
              <div className="payment_wrapper">
                {isRegistered && onboardingCompleted ? (
                  <div className="already_bank">
                    <p>
                      売上げ受取口座は下記からご確認頂けます
                      <span className="bank_account_explain_link">
                        <br />
                        <span>【重要】</span>
                        売上げ受取口座と入金スケジュールの変更方法については
                        <Link
                          to={paths.introduction.change_sales_account}
                          target="_blank"
                        >
                          こちら
                        </Link>
                      </span>
                    </p>
                    <div className="already_bank_link">
                      <Button
                        as="a"
                        className="payment_button"
                        href={paths.stripeDashboard}
                        target="_blank"
                        rel="noopener noreferrer"
                        loading={isLoading}
                        disabled={isLoading}
                      >
                        <span>売上げ受取口座を確認する</span>
                        <br />
                        <span>（ Stripe に移動します ）</span>
                      </Button>
                    </div>
                    <div className="bank_account_explain_link">
                      <Link
                        to={paths.introduction.sales_account}
                        target="_blank"
                      >
                        Stripe について
                      </Link>
                    </div>
                  </div>
                ) : (
                  <div className="b__unregistered">
                    <div className="description">
                      <div className="bank_account_explain_link">
                        <span>【重要】</span>
                        売上げ受取口座登録の詳しい説明は
                        <Link
                          to={paths.introduction.sales_account}
                          target="_blank"
                        >
                          こちら
                        </Link>
                      </div>
                      {/* 審査中・利用不可のユーザーは登録操作を終えているため、
                          「登録できていない」旨の警告は出さない。 */}
                      {!isUnderReview && !isRestricted && (
                        <span className="important">
                          正しく登録ができていないため、売上金が入金されない事例が多発しています。
                          <br />
                          必ず
                          <Link
                            to={paths.introduction.howto_sales_account}
                            target="_blank"
                          >
                            ガイド
                          </Link>
                          に従って登録を行ってください。
                        </span>
                      )}
                      <UnregisteredMessage
                        isRegistered={isRegistered}
                        isUnderReview={isUnderReview}
                        isRestricted={isRestricted}
                      />
                    </div>

                    {!isRestricted && (
                      <Button
                        className="payment_button"
                        onClick={
                          isRegistered
                            ? handleResumeOnboarding
                            : handleConnectStripe
                        }
                        loading={isLoading}
                        disabled={isLoading}
                      >
                        <span>
                          {isUnderReview
                            ? '登録内容を確認する'
                            : isRegistered
                            ? '口座登録を再開する'
                            : '売上げ受取口座を登録する'}
                        </span>
                        <br />
                        <span>（外部サイトに移動します）</span>
                      </Button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </section>
        </span>
      </section>
    </div>
  );
}

export default enhance((props) => <BankAccount {...props} />);
